<footer class="footer">
    <div class="footer-glow" aria-hidden="true"></div>

    <div class="footer-shell">

        <section class="newsletter">

            <div class="newsletter-content">
                <h2>Get event invites in your inbox</h2>

                <p>One short email a month — workshops, game nights, visa deadlines.</p>
            </div>

            @if (success()) {
            <!-- Success State -->
            <div class="subscribe-success">
                <div class="success-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17L4 12" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <span class="success-message">
                    @if (alreadySubscribed()) {
                    You're already subscribed!
                    } @else {
                    Successfully subscribed!
                    }
                </span>
                <button type="button" class="success-dismiss" (click)="dismissSuccess()" aria-label="Dismiss">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
            } @else {
            <!-- Subscribe Form -->
            <!-- An invalid email turns the whole pill red and explains why just under it,
                 rather than squeezing the message against the input's edge. -->
            <!-- One grid cell for the pill and its messages, so they stack under it. -->
            <div class="subscribe-field">
            <form class="subscribe-form" [class.has-error]="hasEmailError()" [formGroup]="subscribeForm"
                (ngSubmit)="onSubmit()">
                <div class="subscribe-input-wrapper">
                    <input
                        type="email"
                        formControlName="email"
                        placeholder="you@university.de"
                        aria-label="Email address"
                        [attr.aria-invalid]="hasEmailError()"
                        [attr.aria-describedby]="hasEmailError() ? 'subscribe-email-error' : null" />
                </div>

                <button type="submit" [disabled]="isLoading()">
                    @if (isLoading()) {
                    <span class="btn-spinner"></span>
                    Subscribing...
                    } @else {
                    Subscribe
                    }
                </button>
            </form>

            @if (hasEmailError()) {
            <p class="input-error" id="subscribe-email-error" role="alert">{{ getEmailError() }}</p>
            }

            @if (error()) {
            <p class="subscribe-error">{{ error() }}</p>
            }
            </div>
            }

        </section>

        <div class="footer-content">

            <!-- The header's "About Us" anchor, until the page gets its own section. -->
            <div class="footer-brand" id="about-us">

                <a class="footer-logo-link" routerLink="/" aria-label="StudiFlats Community Club — home">
                    <img class="footer-logo" src="assets/footer/logo.png"
                        alt="StudiFlats Community Club" width="220" height="96" />
                </a>

                <!-- Footer values come from the API; a missing one reads "coming soon". -->
                <p [class.is-soon]="!about()">{{ about() || 'More about the club is coming soon.' }}</p>

                @if (socialLinks().length) {
                <div class="social-links">
                    @for (link of socialLinks(); track link.label) {
                    <a [href]="link.url" [attr.aria-label]="link.label" target="_blank" rel="noopener">
                        <img [src]="getSocialIcon(link)" alt="" aria-hidden="true" />
                    </a>
                    }
                </div>
                } @else {
                <!-- No links from the API: the design's icons; a click shows a small tip. -->
                <div class="social-links">
                    @for (icon of socialIcons; track icon.label) {
                    <button type="button" [attr.aria-label]="icon.label" appNotAvailableTip>
                        <img [src]="icon.icon" alt="" aria-hidden="true" />
                    </button>
                    }
                </div>
                }

            </div>


            <div class="footer-column">

                <h3>Quick Links</h3>

                <ul>
                    @for (link of quickLinks().length ? quickLinks() : pageLinks; track link.label) {
                    <li>
                        @if (link.href) {
                        <a [href]="link.href" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
                        } @else {
                        <a [routerLink]="link.path" [fragment]="link.fragment">{{ link.label }}</a>
                        }
                    </li>
                    }
                </ul>

            </div>


            <div class="footer-column" id="contact-us">

                <h3>Contact us</h3>

                <ul>
                    @if (email()) {
                    <li>
                        <a [href]="'mailto:' + email()">{{ email() }}</a>
                    </li>
                    }
                    @if (phone()) {
                    <li>
                        <a [href]="'tel:' + phone()">{{ phone() }}</a>
                    </li>
                    }
                    @if (address()) {
                    <li>
                        <span>{{ address() }}</span>
                    </li>
                    }
                    @if (workingHours()) {
                    <li>
                        <span>{{ workingHours() }}</span>
                    </li>
                    }
                    @if (!hasContactInfo()) {
                    <!-- No contact details from the API: the design's link; a click shows a small tip. -->
                    <li>
                        <button type="button" class="link-btn" appNotAvailableTip>Contact Us</button>
                    </li>
                    }
                    <!-- No About page or section is designed yet: the design's link; a click
                         shows a small tip until product decides where it goes. -->
                    <li>
                        <button type="button" class="link-btn" appNotAvailableTip>About Us</button>
                    </li>
                </ul>

            </div>

        </div>

        <div class="footer-bottom">
            <span [class.is-soon]="!copyright()">{{ copyright() || 'Copyright details coming soon.' }}</span>
        </div>

    </div>

</footer>
